export const caseJSONToText = (json: object): string => {
  const formattedLines: string[] = ['\n'];

  for (const [key, value] of Object.entries(json)) {
    const formattedKey = formatKey(key);
    if (Array.isArray(value) && value.length === 0) {
      continue;
    }

    if (['Case Category', 'Location'].includes(formattedKey) && value === null) {
      formattedLines.push(`**${formattedKey}**: -- Not selected --`);
      continue;
    }

    const description =
      value?.description ||
      (Array.isArray(value) &&
        value.length > 0 &&
        value
          .map((item) => item.description)
          .filter((item) => item)
          .join(', '));

    if (description) {
      formattedLines.push(`**${formattedKey}**: ${description}`);
      continue;
    }

    formattedLines.push(
      `**${formattedKey}**: ${typeof value === 'object' ? JSON.stringify(value) : formatDate(value)}`
    );
  }

  return formattedLines
    .join('\n')
    .replace(/</g, '&lt;') // Replace all < with &lt;
    .replace(/>/g, '&gt;') // Replace all > with &gt;
    .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
    .replace(/\*([^*\n]+)\*/g, '<em>$1</em>');
};

const formatKey = (key: string): string =>
  key
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const formatDate = (value: string): string => {
  const date = new Date(value);
  return isNaN(date.getTime()) ? value : formatDateTimeLocale(date);
};

const formatDateTimeLocale = (date: Date): string =>
  new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);

/**
 * Replaces ISO 8601 datetime strings (e.g. "2026-03-06T16:45:42.9427486+01:00")
 * in free text with locale-formatted dates using the browser's language settings.
 * This catches any raw datetimes that the LLM failed to format.
 */
export const formatISODateTimesInText = (text: string): string =>
  text.replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})/g, (match) => {
    const date = new Date(match);
    return isNaN(date.getTime()) ? match : formatDateTimeLocale(date);
  });
